/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Transfer_Amount_InvalidInputs */

const fr_api_transfer_amount_invalid = /** @type {(inputs: Api_Transfer_Amount_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le montant à virer doit être supérieur à zéro. Vérifiez la facture et sa retenue.`)
};

const en_api_transfer_amount_invalid = /** @type {(inputs: Api_Transfer_Amount_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The transfer amount must be greater than zero. Check the invoice and withholding amount.`)
};

/**
* | output |
* | --- |
* | "The transfer amount must be greater than zero. Check the invoice and withholding amount." |
*
* @param {Api_Transfer_Amount_InvalidInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_transfer_amount_invalid = /** @type {((inputs?: Api_Transfer_Amount_InvalidInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Transfer_Amount_InvalidInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_transfer_amount_invalid(inputs)
	return fr_api_transfer_amount_invalid(inputs)
});